"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dot = exports.DotsContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const getMeasuredSizeBySpinnerSize = (spinnerSize) => {
    const isNumberSize = typeof spinnerSize === 'number';
    if (isNumberSize)
        return `${spinnerSize}px`;
    const isStringSizing = typeof spinnerSize === 'string';
    if (isStringSizing)
        return `${spinnerSize}`;
    return null;
};
exports.DotsContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;

  & > span {
    background: ${({ spinnerColor }) => spinnerColor};

    width: ${({ spinnerSize }) => getMeasuredSizeBySpinnerSize(spinnerSize)};
    height: ${({ spinnerSize }) => getMeasuredSizeBySpinnerSize(spinnerSize)};
  }

  @keyframes anim {
    0% {
      top: 0;
    }

    33.3333% {
      top: calc(
        (${({ spinnerSize }) => getMeasuredSizeBySpinnerSize(spinnerSize)}) / 2
      );
    }

    66.3333% {
      top: calc(
        (-${({ spinnerSize }) => getMeasuredSizeBySpinnerSize(spinnerSize)}) / 2
      );
    }

    100% {
      top: 0;
    }
  }
`;
exports.Dot = styled_components_1.default.span `
  display: block;
  border-radius: 50%;
  position: relative;
  margin: 0 5px;

  &[data-dot='1'] {
    animation: anim 1s linear 0s infinite;
  }

  &[data-dot='2'] {
    animation: anim 1s linear 0.25s infinite;
  }

  &[data-dot='3'] {
    animation: anim 1s linear 0.5s infinite;
  }

  &[data-dot='4'] {
    animation: anim 1s linear 0.75s infinite;
  }
`;
